





























import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { ToolbarDeactivations, ToolbarModule } from '@/store/modules/toolbar'


@Component({
    name: 'toolbar'
})
export default class Toolbar extends Vue {

    get zoom() {
       return ToolbarModule.zoom 
    }

    set zoom(zoom: number | string) {
        let zoomNumber = Number(zoom)
        if (!Number.isNaN(zoomNumber)) {
            ToolbarModule.SetZoom(zoomNumber) 
        }
    }

    get rotation() {
       return ToolbarModule.rotation 
    }

    set rotation(rotation: number | string) {
        let rotationNumber = Number(rotation)
        if (!Number.isNaN(rotationNumber)) {
            ToolbarModule.SetRotation(rotationNumber) 
        }
    }

    get disabledZoomAndRotation() {
        return ToolbarModule.deactivated & ToolbarDeactivations.ZoomAndRotation
    }

    get disabledTrash() {
        return ToolbarModule.deactivated & ToolbarDeactivations.Deletion
    }

    zoomOffset(offset: number) {
        if (!this.disabledZoomAndRotation) {
            ToolbarModule.OffsetZoom(offset)
        }
    }

    rotate(offset: number) {
        if (!this.disabledZoomAndRotation) {
            ToolbarModule.OffsetRotation(offset)
        }
    }

    deselect() {
        if (!this.disabledTrash) {
            ToolbarModule.Deselect()
        }
    }

}
